import React, { useCallback, useState } from 'react';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import PasswordTips from './PasswordTips';

const InputPasswd = ({ label, value, inputCb, id, autoComplete = '', error, classContainer = '', showTips, name, handleTipsPassword }) => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = useCallback(() => setIsVisible((prev) => !prev), []);

  const IconEye = isVisible ? RemoveRedEyeOutlinedIcon : VisibilityOffOutlinedIcon;
  return (
    <div className={`relative ${classContainer}`}>
      <label className="block text-gray-700 text-sm ml-2 mb-2" htmlFor={id}>
        {label}
      </label>
      <div className="flex flex-row h-10">
        <input
          value={value}
          onChange={(e) => inputCb(e)}
          className=" text-gray-800 leading-tight pl-4 h-10 border-gray-300  border-y border-l rounded-full rounded-r-none w-full py-1 px-2 outline-none "
          type={isVisible ? 'text' : 'password'}
          placeholder="********"
          autoComplete={autoComplete}
          name={id}
        />
        {error && <span className={'absolute bottom-[-16px] text-xs text-red-500'}>{error?.message}</span>}

        <span className="cursor-pointer flex items-center bg-white rounded-full rounded-l-none border-gray-300  border-y border-r px-2 font-bold text-grey-100">
          <IconEye className="w-6 h-6 fill-gray-500 hover:fill-black" onClick={toggleVisibility} />
        </span>
      </div>
      {showTips && <PasswordTips name={name} onChangeValid={handleTipsPassword} />}
    </div>
  );
};

export default InputPasswd;
